const html = String.raw;
(($) => {
    "use strict";

    /* Showing general error messages */
    let $errorModal = $(".js-error-modal");

    $.showError = (error) => {
        let $modalErrorMsg = $(".modal-error__msg");
        $modalErrorMsg.html(error);
        $errorModal.iziModal("open", {
            transition: "fadeInDown",
        });
    };

    $.pluralize = (str, num) => {
        if (num > 1 && $.langCookie === "en") {
            return str + "s";
        }
        return str;
    };

    /* Get parameter from url */
    let urlParams;
    $.getUrlParameter = (sParam) => {
        if (!urlParams) {
            urlParams = new URL(window.location.href).searchParams;
        }
        return urlParams.get(sParam);
    };

    $.getDecodedParam = function (key) {
        const urlParams = new URLSearchParams(window.location.search);
        const encoded = urlParams.get('data');
        if (!encoded) return null;

        try {
            const decoded = atob(encoded);
            const params = JSON.parse(decoded);
            return params[key] || null;
        } catch (e) {
            console.warn("Failed to decode params", e);
            return null;
        }
    };

    /* Get campaign parameters from url */
    $.getCampaign = () => {
        const url = new URL(window.location.href);
        const params = ["m_campaign", "m_pub", "m_source", "m_place", "m_format", "utm_source", "utm_medium", "utm_campaign"];

        for (const param of params) {
            const value = url.searchParams.get(param);
            if (value) {
                localStorage.setItem(param, value);
            }
        }
    };

    $.convertDeliveryName = function convertDeliveryName(str) {
        if (str == null) {
            str = "-";
        } else {
            str = str.replace("Q1", localize.translations.delivery_q1_full || localize.translations.delivery_q1);
            str = str.replace("Q2", localize.translations.delivery_q2_full || localize.translations.delivery_q2);
            str = str.replace("Q3", localize.translations.delivery_q3_full || localize.translations.delivery_q3);
            str = str.replace("Q4", localize.translations.delivery_q4_full || localize.translations.delivery_q4);

            str = str.replace(/\d{4}/g, "$&.");
        }

        return str;
    };

    $(() => {
        $.getCampaign();
    });
})(jQuery);
